import React, { useState, useRef, useEffect } from 'react'
import { AnimatePresence } from 'framer-motion';
import { motion } from 'framer-motion';
import Classes from './AddSubscription.module.css';
import { useNavigate } from 'react-router-dom';

export default function ClientsDropDown({ clients, selectedSubcoach, setSelectedSubcoach }) {
  const [dropDown, setDropDown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropDown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelectCoach = (coach) => {
    // If coach is offline or status is disabled, skip or show alert?
    if (!coach.availability?.isOnline || coach.status === 'disabled') {
      return; // or show a toast "Coach is offline"
    }
    setSelectedSubcoach(coach);
    setDropDown(false);
  };

  return (
    <div className={Classes.dropDown} ref={dropdownRef}>
      {/* Dropdown Head */}
      <div
        className={`flexAlign10 pointer mr10`}
        onClick={() => setDropDown(!dropDown)}
      >
        <div
          className={Classes.inputField}
          style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
        >
          {/* Subcoach Name or default text */}
          <h5 className={Classes.placeholder} >{selectedSubcoach ? selectedSubcoach.name : 'Anyone can pay this invoice'}</h5>
          <img
            className={Classes.dropDownHeadImg}
            src='/assets/images/arrow-down.svg'
            alt='arrow'
            style={{ height: '14px', transform: dropDown ? 'rotate(180deg)' : 'rotate(0deg)' }}
          />
        </div>
      </div>

      <AnimatePresence>
        {dropDown && (
          <motion.div
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.15 }}
            className={Classes.dropDownBody}
            style={{ top: '44px', left: '0', width: '100%' }}
          >
            <div className={`${Classes.dropDownBodyInner} scroll`}>
              {clients.map((client) => {
                // Check if coach is online or not
                return (
                  <div
                    key={client._id}
                    className={Classes.dropDownElem}
                    style={{
                      padding: '5px 10px',
                    }}
                  >
                    <h2 className={Classes.tableAvatar}>
                      <a href="#" className={Classes.avatar}>
                        <img
                          className="avatar-img"
                          src={'/assets/images/user.png'}
                          alt={client.name}
                        />
                      </a>
                      <span className={Classes.tableHeadName}>
                        <div className={Classes.tableMobData}>
                          <div>
                            <h5 className='truncate'>{client.name}</h5>
                            <p className='truncate'>{client.email}</p>
                          </div>
                        </div>
                      </span>
                    </h2>
                  </div>
                );
              })}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <input type="hidden" aria-label="Without label" readOnly />
    </div>
  );
}

